import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const PERFORMANCE_CONFIG = enabledOn(
  PlatformSlug.DATBooster,
  PlatformSlug.OATBooster,
  PlatformSlug.DATCrusher,
  PlatformSlug.INBDEBooster,
  PlatformSlug.CasperBooster,
  PlatformSlug.NBDHEBooster,
  PlatformSlug.NDEBCrusher,
  PlatformSlug.GREBooster
)

export const isPerformanceAvailable = (slug?: PlatformSlug) => isFeatureAvailable(PERFORMANCE_CONFIG, slug)
